module.exports = __webpack_public_path__ + "img/gjng2900_1.6d78e015.svg";